import {combineReducers} from 'redux'
import productReducer from "./products";
import {cartReducer} from "./cart";
import {wishListReducer} from "./wishList";
import compareListReducer from "./compare";
import photographyReducer from '../Photography/photographySlice';
import filmsReducer from '../Films/FilmsSlice';
import CareersReducer from '../Careers/CareersSlice';
import TravelReducer from '../Travel/TravelSlice';
import back from '../Travel/TravelSlice';
import SliderReducer from '../Sliderhero/SliderSlice';
import backyardReducer from '../Backyard/BackyardSlice';
import EditorialReducer from '../Editorial/EditorialSlice';
import OrdersReducer from '../Order/OrderSlice';
import TestimonialReducer from '../Testimonial/TestimonialSlice';


const rootReducer = combineReducers({
    data: productReducer,
    cartList: cartReducer,
    wishList: wishListReducer,
    photography:photographyReducer,
    films:filmsReducer,
    compareList: compareListReducer,
    careers:CareersReducer,
    travel:TravelReducer,
    slider:SliderReducer,
    backyard:backyardReducer,
    editorial:EditorialReducer,
    orders:OrdersReducer,
    Testimonials:TestimonialReducer
    
});

export default rootReducer;